const FormWrapper = (props) => {
    return (
        <div className="mt-6 md:mt-5 space-y-6 md:space-y-5">
            <span className="block text-red-700">{props.error}</span>
            {props.children}
        </div>
    )
}

export default FormWrapper